let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e6NhJ")).then(() => parcelRequire('kqAV4'));